/**
 * PranaFlow Academy LMS
 * Demo Class System API Client Services
 */

import { apiGet, apiPost, apiPut, apiDelete } from './api';
import { createRazorpayOrder } from './studentService';

// --- Admin: Demo Courses ---
export async function getDemoCourses(params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiGet(`/admin/demo-courses.php${query ? '?' + query : ''}`);
}

export async function createDemoCourse(data) {
  return apiPost('/admin/demo-courses.php', data);
}

export async function updateDemoCourse(data) {
  return apiPut('/admin/demo-courses.php', data);
}

export async function deleteDemoCourse(id, force = false) {
  return apiDelete(`/admin/demo-courses.php?id=${id}&force=${force ? 'true' : 'false'}`);
}

// --- Admin: Demo Batches ---
export async function getDemoBatches() {
  return apiGet('/admin/demo-batches.php');
}

export async function createDemoBatch(data) {
  return apiPost('/admin/demo-batches.php', data);
}

export async function updateDemoBatch(data) {
  return apiPut('/admin/demo-batches.php', data);
}

export async function deleteDemoBatch(id, force = false) {
  return apiDelete(`/admin/demo-batches.php?id=${id}&force=${force ? 'true' : 'false'}`);
}

// --- Admin: Demo Students ---
export async function getDemoStudents(courseId = 0, status = '', demoBatchId = 0, isNew = '') {
  let url = '/admin/demo-students.php?';
  if (courseId > 0) url += `course_id=${courseId}&`;
  if (status) url += `status=${status}&`;
  if (demoBatchId > 0) url += `demo_batch_id=${demoBatchId}&`;
  if (isNew !== '') url += `is_new=${isNew}&`;
  return apiGet(url);
}

export async function updateDemoStudent(data) {
  return apiPut('/admin/demo-students.php', data);
}

export async function resetDemoStudentPassword(studentId, data) {
  return apiPut('/admin/demo-students.php', { id: studentId, action: 'reset_password', ...data });
}

export async function changeDemoPassword(payload) {
  return apiPost('/auth/change-demo-password.php', payload);
}

export async function createDemoStudent(data) {
  return apiPost('/admin/demo-students.php', data);
}

export async function deleteDemoStudent(id) {
  return apiDelete(`/admin/demo-students.php?id=${id}`);
}

// --- Teacher: Demo Batches ---
export async function getTeacherDemoBatches() {
  return apiGet('/teacher/demo-batches.php');
}

export async function updateTeacherDemoBatch(data) {
  return apiPut('/teacher/demo-batches.php', data);
}

export async function sendTeacherDemoNotification(id) {
  return apiPost('/teacher/demo-batches.php', { id });
}

// --- Public: Registration & Payments ---
export async function createDemoOrder(data) {
  const mappedData = {
    payment_type: 'demo_course',
    demo_course_id: data.demo_course_id,
    preferred_date: data.preferred_date,
    preferred_time: data.preferred_time,
    country_code: data.country_code,
    country_name: data.country_name,
    currency_code: data.currency_code,
    studentDetails: {
      name: data.name,
      email: data.email,
      phone: data.mobile_number
    },
    // Unified payload keys set to null
    course_id: null,
    batch_id: null,
    student_id: null,
    enrollment_id: null,
    installment_id: null,
    installment_number: null,
    amount: null,
    purpose: 'demo_course_payment'
  };
  return createRazorpayOrder(mappedData);
}

export async function verifyDemoPayment(data) {
  if (data.is_free) {
    const mappedFreeData = {
      is_free: true,
      payment_type: 'demo_course',
      demo_course_id: data.demo_course_id,
      preferred_date: data.preferred_date,
      preferred_time: data.preferred_time,
      country_code: data.country_code,
      country_name: data.country_name,
      currency_code: data.currency_code,
      studentDetails: {
        name: data.name,
        email: data.email,
        phone: data.mobile_number
      }
    };
    return apiPost('/payments/verify-razorpay-payment.php', mappedFreeData);
  }
  return apiPost('/payments/verify-razorpay-payment.php', data);
}

// --- Auth: Demo Student Login ---
export async function sendDemoLoginOtp(channel, value) {
  return apiPost('/auth/demo-login.php', { channel, value });
}

export async function verifyDemoLoginOtp(channel, value, otp) {
  return apiPost('/auth/demo-verify-otp.php', { channel, value, otp });
}

export async function getCurrentDemoStudent() {
  return apiGet('/auth/demo-me.php');
}



// Get trial classroom content for demo students
export async function getDemoClassroom() {
  return apiGet('/auth/demo-classroom.php');
}

// Get approved trial videos for the authenticated demo student
export async function getDemoVideos() {
  return apiGet('/student/demo-videos');
}
